export const globalStore = {
    idlogin: null,
    idusuario: null,
    idmunicipio: null,
    idprograma: null,
    idipprestador: null,
    ckadmin: 'N',
    ckipprestador: 'N',
    nmusuario: '',
    nmmunicipio: '',
    nmipprestador: '',

    ckpermitir_parcelar: 'N',
    cobr_prazo_inicial: 0,
    latitude: 0,
    longitude: 0,

    itensPorPagina: 12,

    perfil: {
        id: 0,
        agr_acesso: 0,
        gab_acesso: 0,
        ip_acesso: 0,
        obras_acesso: 0,
        sis_admin: 0,
    },
};